

import { RegisterControl } from "@eavfw/apps";
import { CustomerQuotationFormsView } from "./CustomerQuotationFormsView";

RegisterControl("CustomerQuotationFormsView", CustomerQuotationFormsView);